module.exports = __webpack_public_path__ + "img/up_angle.ca256968.jpg";